type SummaryItem = {
  label: string;
  value: string;
};

type UserSummaryCardProps = {
  title?: string;
  items: SummaryItem[];
  className?: string;
};

export function UserSummaryCard({
  title,
  items,
  className = "",
}: UserSummaryCardProps) {
  return (
    <div className={`rounded-xl border border-gray-200 bg-gray-50 p-3 ${className}`}>
      <div className="mb-1 text-xs font-semibold text-gray-500">{title}</div>
      <div className="text-sm text-gray-700">
        {items.map((item) => (
          <div key={item.label}>
            <b>{item.label}:</b> {item.value || "-"}
          </div>
        ))}
      </div>
    </div>
  );
}
